module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"flight_time.value.zero":"-","flight_time.value":"{count} วินาที"}}')
  delete Component.options._Ctor
}
